export interface SplitAmountResult {
  credit: number;
  debit: number;
}

/**
 * Convertit un montant exprimé en euros (positif ou négatif)
 * en valeurs entières de crédit / débit exprimées en centimes.
 */
export function splitAmount(rawAmount: string): SplitAmountResult {
  if (!rawAmount) {
    return { credit: 0, debit: 0 };
  }

  const normalized = rawAmount.replace(',', '.').trim();
  const parsed = Number(normalized);

  if (!Number.isFinite(parsed)) {
    return { credit: 0, debit: 0 };
  }

  const cents = Math.round(parsed * 100);

  if (cents > 0) {
    return { credit: cents, debit: 0 };
  }

  if (cents < 0) {
    return { credit: 0, debit: Math.abs(cents) };
  }

  return { credit: 0, debit: 0 };
}

/**
 * Convertit un montant en euros (signé, virgule ou point) en centimes.
 * Retourne undefined si la saisie est vide ou invalide, pour distinguer
 * "pas de filtre" d'un filtre à 0.
 */
export function parseAmountToCents(rawAmount: string): number | undefined {
  if (!rawAmount.trim()) {
    return undefined;
  }

  const parsed = Number(rawAmount.replace(',', '.').trim());

  if (!Number.isFinite(parsed)) {
    return undefined;
  }

  return Math.round(parsed * 100);
}

/**
 * Formatte un couple crédit / débit en un montant unique pour un champ utilisateur.
 */
export function formatAmountInput(credit: number, debit: number): string {
  const cents = credit - debit;
  const value = cents / 100;
  if (Number.isInteger(value)) {
    return value.toString();
  }
  return value.toFixed(2).replace(/\.?0+$/, '');
}

